import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import {
  endpoints, cohortEndpoint,
} from '@/constants/urls';

const cohorts = (filter, includePrivate, includeInternal, page, pageSize, requestable) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  if (requestable) {
    params.requestable = true;
  }

  if (includePrivate !== includeInternal) {
    if (includePrivate) {
      params.private = true;
    } else {
      params.internal = true;
    }
  }

  return (
    request({
      url: endpoints.COHORTS,
      params,
      method: 'GET',
    })
  );
};

const cohort = (code) => request({
  url: cohortEndpoint(code),
  method: 'GET',
});

const cohortQueries = (code) => request({
  url: `${cohortEndpoint(code)}/queries`,
  method: 'GET',
});

const destroy = ({ code }) => request({
  url: cohortEndpoint(code),
  method: 'DELETE',
});

const create = ({
  code,
  name,
  description,
  visibility,
  queries,
}) => {
  const data = {
    code,
    name,
    description,
    queries,
    visibility,
  };

  if (!hasMinimumLength(data.code)) {
    delete data.code;
  }

  return request({
    url: endpoints.COHORTS,
    data,
    method: 'POST',
  });
};

const update = (code, properties) => request({
  url: cohortEndpoint(code),
  data: properties,
  method: 'PATCH',
});

const CohortsService = {
  cohorts,
  cohort,
  create,
  update,
  destroy,
  cohortQueries,
};

export default CohortsService;
